import db from '../db'
import { DamageInvoice } from '../interfaces'
import { liveQuery } from '../livequery'

// @ts-ignore
export const invoices = liveQuery(db.invoices_sin, DamageInvoice)
export function initialization(interval = 60000*3) {
    invoices.init()
    const syncInterval = setInterval(() => {
        let lastUpdate
        invoices.getLastUpdateState().subscribe((r) => lastUpdate = r)
        // @ts-ignore
        if (lastUpdate && Math.abs(Date.now() - lastUpdate.getTime()) >= interval) {
            invoices.sync()
        }
    }, 1000)
    return [syncInterval, () => clearInterval(syncInterval)]
}
export default invoices
